import React, { useContext } from 'react';
import cx from 'classnames';
import RecorderDrawerContext from '../../Context';
import { RecorderState } from '@vimily/bonjoro-ui-components-v2/VideoRecorder';

export function RedoButton() {
  const {
    setRecorderState,
    setVideoBlob,
    setGeneratedThumbnails,
    setSelectedThumbnailIndex,
    onRecordingRedo,
  } = useContext(RecorderDrawerContext);

  const onRedoClick = () => {
    setRecorderState(RecorderState.Idle);
    setVideoBlob(undefined);
    setGeneratedThumbnails([]);
    setSelectedThumbnailIndex(undefined);
    onRecordingRedo?.();
  };

  return (
    <button
      className={cx([
        'v2-bg-black/25 hover:v2-bg-black/50 px-2 rounded-full flex flex-row',
        'top-4 right-3 absolute border-none hover:scale-110 gap-x-2 items-center',
        'transition-all p-1 v2-group',
      ])}
      onClick={onRedoClick}
    >
      <i className='icon icon-redo !v2-bg-white v2-duration-400 v2-transition-all v2-transform group-hover:-v2-rotate-90' />
      <span className='text-base font-bold v2-text-white'>Redo</span>
    </button>
  );
}
